import  gql  from 'graphql-tag'

export const permissions = gql`query permissions{ 
    permissions{
        edges{
            node{
                id
                name
            }
        }
    }
}`;
